import { Typography, TypographyVariant, Image } from "@onmo/ui";
import { FC, HTMLAttributes, useEffect, useMemo, useRef } from "react";
import { useQuery } from "@apollo/client";
import { Query } from "@onmo/graphql/graphql";
import { getUserProfileCaGQL } from "../../../graphql";
import { useStyles } from "./ProfileStats.style";
import Gem from "../../../assets/icons/gem_1x.webp";
import Gem2x from "../../../assets/icons/gem_2x.webp";
import Gem3x from "../../../assets/icons/gem_3x.webp";
import { ProfileMd } from "../../../models/profile";
import { useTranslation } from "react-i18next";

interface IProfileStats extends HTMLAttributes<HTMLDivElement> {
  id?: string;
}

const ProfileStats: FC<IProfileStats> = ({ id = "" }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { data: dataProfile } = useQuery<{ user: Query["user"] }>(
    getUserProfileCaGQL,
    {
      variables: { id },
      fetchPolicy: "cache-and-network",
    },
  );

  const stats = useMemo(() => {
    return ProfileMd.getTotalValue(
      dataProfile?.user.totalTimePlayed ?? 0,
      dataProfile?.user.totalPlayedGames,
      dataProfile?.user.xp,
    );
  }, [dataProfile?.user.totalPlayedGames, dataProfile?.user.totalTimePlayed]);

  return (
    <div className={classes.profileStats}>
      <Typography variant={TypographyVariant.BodyB2Bold}>
        {t("profile_my_stats")}
      </Typography>
      {stats.map((item, idx) => (
        <div key={item.key + idx} className={classes.statItem}>
          <div className={classes.label}>
            <Image
              src={item.icon.src1x}
              src2x={item.icon.src2x}
              src3x={item.icon.src3x}
              className={classes.icon}
            />
            <Typography variant={TypographyVariant.BodyB5Regular}>
              {t(item.label)}
            </Typography>
          </div>
          <Typography
            variant={TypographyVariant.BodyB4Bold}
            className={classes.value}
          >
            {item.showGem && <Image src={Gem} src2x={Gem2x} src3x={Gem3x} />}
            {item.key === "totalTime"
              ? t("hours_display", { count: item.value })
              : item.value}
          </Typography>
        </div>
      ))}
    </div>
  );
};
export default ProfileStats;
